import React, { useContext, useEffect, useState } from "react";
import { ServerContext } from "../../contex/ServerContext";
import { Link, useParams } from "react-router-dom";
import "./itemDetails.css";
import ReactImageZoom from "react-image-zoom";
import { useCart } from "react-use-cart";
import { Button, Table } from "react-bootstrap";
import { IMG_URL } from "../../constants";

function ItemDetails() {
  const { get } = useContext(ServerContext);
  const [getValue] = get;
  const params = useParams();

  const [detailItem, setDetailItem] = useState([]);

  const { addItem } = useCart();
  useEffect(() => {
    if (params) {
      getValue.forEach((get) => {
        if (get._id === params.id) setDetailItem(get);
      });
    }
  }, [params, getValue]);
  // src={IMG_URL + get.image}
  const customization = {
    width: 400,
    height: 450,
    zoomPosition: "original",
    img: IMG_URL + detailItem.image,
  };

  console.log(detailItem);

  return (
    <div className="ItemDetails">
      <div className="item_header container py-2 ">
        <i>#{detailItem.categories}</i>
      </div>
      <br />
      <div className="item_main">
        <div className="item_img">
          <ReactImageZoom {...customization} />
        </div>
        <div className="item_content">
          <br />
          <h1>
            <b>{detailItem.name}</b>
          </h1>
          <br />
          <p>{detailItem.description}</p>
          <br />
          <h5>
            <b>${detailItem.price}</b>
          </h5>
          <br />
          <i>
            <b>INFO GUIDE:</b>
          </i>

          <div className="table" style={{ paddingTop: "5px" }}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th style={{ padding: "15px" }}>Size (Size Guide)</th>
                  <th style={{ padding: "15px" }}>S, M, L, XL,</th>
                </tr>
              </thead>
            </Table>
          </div>
          <br />
          <div className="cart_option">
            <Link to="/cart">
              <Button
                variant="dark"
                style={{ borderRadius: "50px" }}
                onClick={() => addItem(detailItem)}
              >
                Add to Card
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ItemDetails;
